// import React, { useState, useEffect } from 'react';
// // import { toAbsoluteUrl } from './AssetHelpers';
// import { toAbsoluteUrl } from '../../../../../../../_metronic/helpers';
// // import { useAuth } from '../../app/modules/auth';
// import { useAuth } from '../../../../../auth';
// interface AccordionItemProps {
//     id: number;
//     title: string;
//     country: string;
//     processedBetween: string;
//     imageSrc: string;
//     organization: string;
//     description: string;
//     certifications: string;
//     expandedAccordion: number | null;
//     onToggle: (id: number) => void;
// }
// interface DdpCProps {
//     user: any;
// }
// interface ProgressBarProps {
//     label: string;
//     percentage: number;
//     colorClass: string;
// }

// const DdpModal: React.FC<DdpCProps> = ({ user }) => {


//     console.log("user in ddp is ", user)


//     const [expandedSection, setExpandedSection] = useState<string>('details');
//     const [expandedAccordion, setExpandedAccordion] = useState<number | null>(null);
//     const [activeTab, setActiveTab] = useState<string>('description');
//     const [mainImage, setMainImage] = useState(user.productImages?.[0]?.url || '');

//     // const [mainImage2, setMainImage2] = useState<string>('/sibig.jpg');
//     const [progressValues, setProgressValues] = useState({
//         co2: 70,
//         water: 50,
//         waste: 30
//     });

//     const [mainImage2, setMainImage2] = useState<string>(user?.socialImpact?.[0]?.url || '/sibig.jpg');

//     useEffect(() => {
//         // Animate progress bars on component mount
//         const timer = setTimeout(() => {
//             setProgressValues({ co2: 70, water: 50, waste: 30 });
//         }, 500);
//         return () => clearTimeout(timer);
//     }, []);

//     // const toggleSection = (section: string) => {
//     //     setExpandedSection(expandedSection === section ? '' : section);
//     // };



//     const toggleSection = (section: string) => {
//         const newSection = expandedSection === section ? '' : section;
//         setExpandedSection(newSection);

//         // Auto-open first accordion when Material Traceability is opened
//         if (section === 'traceability' && newSection === 'traceability') {
//             setExpandedAccordion(1);
//         } else if (newSection === '') {
//             setExpandedAccordion(null);
//         }
//     };


//     const toggleAccordion = (id: number) => {
//         setExpandedAccordion(expandedAccordion === id ? null : id);
//     };

//     const toggleContent = (contentId: string) => {
//         setActiveTab(contentId);
//     };

//     const changeImage = (src: string) => {
//         setMainImage(src);
//     };

//     const changeImage2 = (src: string) => {
//         setMainImage2(src);
//     };

//     const AccordionItem: React.FC<AccordionItemProps> = ({
//         id,
//         title,
//         country,
//         processedBetween,
//         imageSrc,
//         organization,
//         description,
//         certifications,
//         expandedAccordion,
//         onToggle
//     }) => {
//         const isExpanded = expandedAccordion === id;

//         return (
//             <div className="flex gap-3 mt-4 mb-3">
//                 {/* <div className="">
//                     <div style={{ backgroundColor: '#0a79ac' }} className="w-10 h-10 p-2 rounded-full flex items-center justify-center">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
//                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
//                             className="text-white">
//                             <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
//                             <circle cx="12" cy="10" r="3"></circle>
//                         </svg>
//                     </div>
//                 </div> */}

//                 <div className="bg-white rounded-lg shadow-lg flex-1">
//                     <div className="p-4 cursor-pointer" onClick={() => onToggle(id)}>
//                         <div className="flex justify-between items-center mb-4">
//                             <div className="text-base font-bold mb-1">{title}</div>
//                             <svg
//                                 className={`w-5 h-5 text-gray-500 transition-transform transform ${isExpanded ? 'rotate-180' : ''}`}
//                                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                             </svg>
//                         </div>
//                         <div>
//                             <div className="flex justify-between items-center">
//                                 <p className="font-medium text-sm">Country</p>
//                                 <p className=" text-sm">{country}</p>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <p className="font-medium text-sm">Facility:</p>
//                                 <p className="text-sm">{processedBetween}</p>
//                             </div>
//                         </div>

//                         <div className={`transition-all duration-300 overflow-hidden ${isExpanded ? 'max-h-screen' : 'max-h-0'}`}>
//                             <hr className="w-full my-3" />
//                             {/* <img className="rounded-lg mb-4 h-56 bg-gray-200 w-full object-cover" src={imageSrc} alt={title} />
//                              */}



//                             <img className="rounded-lg mb-4 bg-gray-200 w-full object-cover" style={{ height: 'auto' }} src={imageSrc} alt={title} />


//                             <p className="text-base font-bold mb-1">Organization</p>
//                             <div className="text-sm mb-4 ">{organization}</div>
//                             <div className="text-sm ">{description}</div>
//                             <div className="flex justify-between items-center pt-2">
//                                 <p className="text-base font-bold mb-1">Certifications:</p>
//                                 <p className=" text-sm">{certifications}</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const ProgressBar: React.FC<ProgressBarProps> = ({ label, percentage, colorClass }) => (
//         <div className="my-5">
//             <label className="block mb-1 text-left text-sm font-medium">{label}</label>
//             <div className="flex items-center justify-between">
//                 <div className="bg-gray-200 rounded-full overflow-hidden h-4 w-4/5">
//                     <div
//                         className={`h-full rounded-full transition-all duration-1000 ease-out ${colorClass}`}
//                         style={{ width: `${percentage}%` }}
//                     ></div>
//                 </div>
//                 <span className="block mt-0 font-bold text-sm">{percentage}%</span>
//             </div>
//         </div>
//     );


//     const traceabilityData = user?.processes?.map((process, index) => ({
//         id: index + 1,
//         title: process.processName,
//         country: process.country,
//         processedBetween: process.facilityName, // You can modify this based on your data
//         imageSrc: process.image,
//         organization: process.facilityName,
//         description: `${process.facilityName} located at ${process.address}`,
//         certifications: process.certifications,
//     })) || [];

//     const { currentUser, auth, isFacilityManager, isSupplyChainManager }: any = useAuth()

//     const image = isSupplyChainManager
//         ? auth?.data?.profileImage || ''
//         : isFacilityManager
//             ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
//             : isSupplyChainManager
//                 ? currentUser?.franchiseKycDoc?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
//                 : currentUser?.kycDocument?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
//                 currentUser?.kycDocument?.filter((x) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl


//     return (
//         // <div className="bg-gray-50 min-h-screen font-sans" style={{ color: '#333' }}>
//         <div className="bg-gray-50 min-h-screen" style={{ color: '#333', fontFamily: 'Helvetica, Arial, sans-serif', marginTop: "-40px" }}>

//             <div style={{ backgroundColor: 'white', height: '80px', width: '100%' }}></div>
//             {/* max-w-md */}
//             <div className="px-4  mx-auto" style={{ position: 'relative', zIndex: 10, marginTop: '-40px' }}>
//                 <div className="relative">
//                     {/* Product Details Section */}
//                     <div className="bg-white shadow-lg rounded-lg relative z-10 mb-2 mt-5">
//                         <div className="p-1 cursor-pointer" onClick={() => toggleSection('details')}>
//                             <div className="flex justify-between items-center mb-4">
//                                 {/* <img src="/logo.jpg" alt="Logo" className="h-11" /> */}
//                                 <img className="h-12 rounded" src={image || toAbsoluteUrl('/media/avatars/profile.jpeg')} alt='' />
//                                 <svg
//                                     className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'details' ? 'rotate-180' : ''}`}
//                                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                                 </svg>
//                             </div>
//                         </div>

//                         <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'details' ? 'block' : 'hidden'}`}>
//                             <div className="p-2">
//                                 <p className="mb-2 text-sm">

//                                     {/* At Rive Droite, we thrive to positively impact our environment and the lives of who we collaborate with. Following our unshakable purpose, we have decided to share as much information we have related to our activity. */}


//                                     {user.description}

//                                 </p>
//                                 <hr className="border-t-2 border-gray-300" />
//                                 <h1 className="text-md font-bold mb-2 pt-2 text-sm">

//                                     {user.productName}

//                                 </h1>
//                                 <hr className="border-t-2 border-gray-300 p-2 mt-2" />

                           


//                                 <div className="text-center">
//                                     <div className="flex justify-center">
//                                         <img
//                                             src={mainImage}
//                                             alt="Main Image"
//                                             className="w-4/5 h-auto rounded-lg"
//                                         />
//                                     </div>

//                                     <div className="flex justify-center mt-5">
//                                         {user.productImages.slice(1).map((img, index) => (
//                                             <img
//                                                 key={index}
//                                                 src={img.url}
//                                                 alt={`Thumbnail ${index + 1}`}
//                                                 className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform"
//                                                 onClick={() => changeImage(img.url)}
//                                             />
//                                         ))}
//                                     </div>
//                                 </div>





//                                 <div className="flex justify-between items-center mt-4">
//                                     <p style={{ background: '#12B886' }} className="text-white w-24 text-center py-1 mb-1 rounded text-xs">Best Seller</p>
//                                     <p className="text-sm"></p>
//                                 </div>

//                                 <div className="my-1">
//                                     <div className="flex justify-between items-center px-0">
//                                         <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'description' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('description')}>Description</p>
//                                         <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'practical-info' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('practical-info')}>Practical Information</p>
//                                         <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'our-mission' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('our-mission')}>
//                                             Specification
//                                         </p>
//                                     </div>

//                                     {activeTab === 'description' && (
//                                         <div className="p-2 border border-blue-200 rounded mt-2">
//                                             <p className="text-sm">{user.aboutBrand}</p>
//                                         </div>
//                                     )}

//                                     {activeTab === 'practical-info' && (
//                                         <div className="p-2 border border-blue-200 rounded mt-2">
//                                             <div className="text-sm">
//                                                 {user.aboutItem}
//                                             </div>
//                                         </div>
//                                     )}

//                                     {activeTab === 'our-mission' && (
//                                         <div className="p-2 border border-blue-200 rounded mt-2">
//                                             <p className="text-sm">

//                                                 <div className="space-y-3">
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Material</span>
//                                                         <span className="text-sm">{user.categoryName}</span>
//                                                     </div>
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Plastics</span>
//                                                         <span className="text-sm ">{user.itemName}</span>
//                                                     </div>
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Product</span>
//                                                         <span className="text-sm ">{user.productName}</span>
//                                                     </div>
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Dimension</span>
//                                                         <span className="text-sm ">{user.dimension}</span>
//                                                     </div>
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Weight</span>
//                                                         <span className="text-sm ">{user.weight}</span>
//                                                     </div>
//                                                     <div className="flex justify-between items-center">
//                                                         <span className="font-semibold text-sm">Packaging</span>
//                                                         <span className="text-sm ">-</span>
//                                                     </div>
//                                                 </div>

//                                             </p>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Material Traceability Section */}
//                     <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5">
//                         <div className="p-2 cursor-pointer" onClick={() => toggleSection('traceability')}>
//                             <div className="flex justify-between items-center mb-4">
//                                 {/* <h1 className="text-base mb-1" style={{ fontSize: '20px' }}>Material Traceability</h1> */}
//                                 <div className="text-base mb-1" style={{ fontSize: '20px' }}>Material Traceability</div>
//                                 <svg
//                                     className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'traceability' ? 'rotate-180' : ''}`}
//                                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                                 </svg>
//                             </div>
//                         </div>

//                         <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'traceability' ? 'block' : 'hidden'}`}>
//                             <div className="p-4">
//                                 {traceabilityData.map((item) => (
//                                     <AccordionItem
//                                         key={item.id}
//                                         {...item}
//                                         expandedAccordion={expandedAccordion}
//                                         onToggle={toggleAccordion}
//                                     />
//                                 ))}
//                             </div>
//                         </div>


//                     </div>

                
//                     <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5 text-center">
//                         <div className="p-2 cursor-pointer" onClick={() => toggleSection('impact')}>
//                             <div className="flex justify-between items-center mb-4">
//                                 <div className="text-base mb-1 text-center" style={{ fontSize: '20px' }}>Impact</div>
//                                 <svg
//                                     className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'impact' ? 'rotate-180' : ''}`}
//                                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                                 </svg>
//                             </div>
//                         </div>










//                         <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'impact' ? 'block' : 'hidden'}`}>


//                             <div className="grid grid-cols-2 gap-3 mb-4">
//                                 <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
//                                     <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
//                                         <img src="/media/svg/dashboard/GHG_saving.png" alt="GHG" className="w-6 h-6" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-700">GHG Savings</p>
//                                         <p className="text-sm font-bold">{user?.co2Savings || 0}%</p>
//                                     </div>
//                                 </div>

//                                 <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
//                                     <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
//                                         <img src="/media/svg/dashboard/energy_saved.png" alt="Energy" className="w-6 h-6" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-700">Energy Saved</p>
//                                         <p className="text-sm font-bold">{user?.energySavings || 0}%</p>
//                                     </div>
//                                 </div>

//                                 <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
//                                     <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
//                                         <img src="/media/svg/dashboard/waste_saved.png" alt="Waste" className="w-6 h-6" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-700">Waste Saved</p>
//                                         <p className="text-sm font-bold">{user?.waterSavings || 0}%</p>
//                                     </div>
//                                 </div>

//                                 <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
//                                     <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
//                                         <img src="/media/svg/dashboard/trees_saved.png" alt="Trees" className="w-6 h-6" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-700">Trees Saved</p>
//                                         <p className="text-sm font-bold">{user?.treeSavings || 0}</p>
//                                     </div>
//                                 </div>
//                             </div>




//                             {/* <div className="max-w-lg mx-auto p-5">
//                                 <ProgressBar label="CO2 Reduction" percentage={progressValues.co2} colorClass="bg-green-500" />
//                                 <ProgressBar label="Water Footprint Reduction" percentage={progressValues.water} colorClass="bg-blue-500" />
//                                 <ProgressBar label="Waste Reduction" percentage={progressValues.waste} colorClass="bg-red-400" />
//                             </div> */}



//                             <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-1">
//                                 <hr className="border-t-2 border-gray-300 mb-2" />
//                                 <div className="text-base font-bold mb-1">Social Impact</div>
//                                 <hr className="border-t-2 border-gray-300 p-2 mt-2" />

//                                 {/* <div className="flex justify-around">
//                                     <p className="text-sm p-2 border border-blue-200 rounded mt-2 w-2/5">Waste Picker Engaged<br />24</p>
//                                     <p className="text-sm p-2 border border-blue-200 rounded mt-2 w-2/5">Economic Value Created<br />1,321 USD</p>
//                                 </div> */}

//                                 <div className="text-center">
//                                     <div className="flex justify-center mt-5 mb-5">
//                                         {user?.socialImpact?.map((impact, index) => (
//                                             <img
//                                                 key={index}
//                                                 src={impact.url}
//                                                 alt={`Social Impact ${index + 1}`}
//                                                 className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform"
//                                                 onClick={() => changeImage2(impact.url)}
//                                             />
//                                         ))}
//                                     </div>
//                                     {/* <div className="flex justify-center pb-2">
//                                         <img src={mainImage2} alt="Main Image" className="w-3/4 h-auto rounded-lg" />
//                                     </div> */}
//                                     <div className="pb-2 px-4">
//                                         <img src={mainImage2} alt="Main Image" className="w-full h-auto rounded-lg" />
//                                     </div>
//                                 </div>
//                             </div>



//                         </div>
//                     </div>



//                     <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5">
//                         <div className="p-2 cursor-pointer" onClick={() => toggleSection('End of Life')}>
//                             <div className="flex justify-between items-center mb-4">
//                                 <div className="text-base mb-1" style={{ fontSize: '20px' }}>End of Life</div>
//                                 <svg
//                                     className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'End of Life' ? 'rotate-180' : ''}`}
//                                     fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                                 </svg>
//                             </div>
//                         </div>
//                         <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'End of Life' ? 'block' : 'hidden'}`}>
//                             <div className="p-4">
//                                 {/* Reuse Section */}
//                                 <p className="text-sm text-black font-semibold mb-3 text-left">Reuse Instructions</p>
//                                 <div className="text-sm text-black mb-3">
//                                     {user.reuseInfo[0].text}
//                                 </div>
//                                 <div className="mb-4">
//                                     <img
//                                         alt="Reuse Info"
//                                         src={user.reuseInfo[0].image}
//                                         className="w-full h-auto rounded-lg"
//                                         style={{
//                                             filter: 'invert(1)',
//                                         }}
//                                     />
//                                 </div>
//                                 <div className="text-sm text-blue-500 underline mb-6">
//                                     <a href={user.reuseInfo[0].url} target="_blank" rel="noopener noreferrer">
//                                         {user.reuseInfo[0].url}
//                                     </a>
//                                 </div>

//                                 {/* Repair Section */}
//                                 <p className="text-sm text-black font-semibold mb-3 text-left">Repair Instructions</p>
//                                 <div className="text-sm text-black mb-3">
//                                     {user.repairInfo[0].text}
//                                 </div>
//                                 <div className="mb-4">
//                                     <img
//                                         alt="Repair Info"
//                                         src={user.repairInfo[0].image}
//                                         className="w-full h-auto rounded-lg"
//                                         style={{
//                                             filter: 'invert(1)',
//                                         }}
//                                     />
//                                 </div>
//                                 <div className="text-sm text-blue-500 underline mb-6">
//                                     <a href={user.repairInfo[0].url} target="_blank" rel="noopener noreferrer">
//                                         {user.repairInfo[0].url}
//                                     </a>
//                                 </div>

//                                 {/* Recycle Section */}
//                                 <p className="text-sm text-black font-semibold mb-3 text-left">Recycle Instructions</p>
//                                 <div className="text-sm text-black mb-3">
//                                     {user.recycleInfo[0].text}
//                                 </div>
//                                 <div className="mb-4">
//                                     <img
//                                         alt="Recycle Info"
//                                         src={user.recycleInfo[0].image}
//                                         className="w-full h-auto rounded-lg"
//                                         style={{
//                                             filter: 'invert(1)',
//                                         }}
//                                     />
//                                 </div>
//                                 <div className="text-sm text-blue-500 underline">
//                                     <a href={user.recycleInfo[0].url} target="_blank" rel="noopener noreferrer">
//                                         {user.recycleInfo[0].url}
//                                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>



//                     <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
//                         <div className="p-4 flex justify-center">
//                             <img
//                                 alt="Logo"
//                                 src="/media/logos/enverify2.png"
//                                 className="app-sidebar-logo-default"
//                                 style={{
//                                     filter: 'invert(1)',
//                                     width: '50%',
//                                 }}
//                             />
//                         </div>
//                     </div>



//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DdpModal;





import React, { useState, useEffect } from 'react';
import { toAbsoluteUrl } from '../../../../../../../_metronic/helpers';
import { useAuth } from '../../../../../auth';

interface DdpCProps {
    user: any;
}

// CSS matching exactly the HTML template
const cssStyles = `
    :root {
        --bg: #f6f7fb;
        --card: #ffffff;
        --muted: #6b7280;
        --accent: #10b981;
        --soft-border: #e6e9ef;
        --max-width: 820px;
        --gap: 16px;
        --radius: 12px;
        --shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
        --sans: "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .dpp-container * {
        box-sizing: border-box;
    }

    .dpp-container {
        margin: 0;
        font-family: var(--sans);
        background: var(--bg);
        color: #111827;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding: 24px 12px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;
        min-height: 100vh;
    }

    .dpp-page {
        width: 100%;
        max-width: var(--max-width);
    }

    .dpp-card {
        background: var(--card);
        border-radius: var(--radius);
        box-shadow: var(--shadow);
        overflow: hidden;
        border: 1px solid var(--soft-border);
    }

    .dpp-header {
        height: 76px;
        display: flex;
        align-items: center;
        padding: 12px 16px;
        gap: 12px;
        border-bottom: 1px solid var(--soft-border);
        background: linear-gradient(180deg, rgba(255,255,255,0.8), rgba(255,255,255,0.6));
    }

    .dpp-profile {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
        min-width: 0;
    }

   .dpp-profile img {
    width: 52px;
    height: 52px;
    object-fit: contain;
    object-position: center;
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    flex-shrink: 0;
    max-width: 52px;
    max-height: 52px;
}

    .dpp-profile .dpp-title {
        font-size: 16px;
        font-weight: 600;
        color: #0f172a;
    }

    .dpp-profile .dpp-subtitle {
        font-size: 13px;
        color: var(--muted);
        margin-top: 2px;
    }

    .dpp-content {
        padding: 18px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .dpp-section {
        border-radius: 10px;
        background: linear-gradient(180deg, #fff, #fff);
        padding: 12px;
        border: 1px solid var(--soft-border);
    }

    .dpp-section + .dpp-section {
        margin-top: 8px;
    }

    .dpp-section .dpp-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        cursor: pointer;
        user-select: none;
        padding: 6px;
    }

    .dpp-head-left {
        display: flex;
        gap: 12px;
        align-items: center;
        min-width: 0;
    }

    .dpp-head-title {
        font-size: 15px;
        font-weight: 600;
        color: #0f172a;
    }

    .dpp-head-sub {
        font-size: 13px;
        color: var(--muted);
    }

    .dpp-chev {
        width: 20px;
        height: 20px;
        color: var(--muted);
        transition: transform .28s ease;
        flex-shrink: 0;
    }

    .dpp-chev.rotated {
        transform: rotate(180deg);
    }

    .dpp-body {
        margin-top: 10px;
        padding: 8px 6px 4px 6px;
        border-top: 1px dashed var(--soft-border);
    }

    .dpp-body.hidden {
        display: none;
    }

    .dpp-lead {
        font-size: 14px;
        line-height: 1.45;
        color: #374151;
        margin: 8px 0 12px 0;
    }

    .dpp-product-title {
        font-size: 18px;
        font-weight: 700;
        margin: 0 0 8px 0;
        color: #0f172a;
    }

    .dpp-media {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }

    .dpp-main-image {
        width: 100%;
        max-width: 420px;
        max-height: 300px;
        min-height: 300px;
        border-radius: 10px;
        object-fit: cover;
        display: block;
    }

    .dpp-thumbs {
        display: flex;
        gap: 10px;
        overflow: auto;
        padding-bottom: 4px;
        width: 100%;
        justify-content: center;
    }

    .dpp-thumbs img {
        width: 86px;
        height: 64px;
        object-fit: cover;
        border-radius: 8px;
        cursor: pointer;
        border: 2px solid transparent;
        transition: transform .18s ease, border-color .18s;
        flex: 0 0 auto;
    }

    .dpp-thumbs img:hover {
        transform: scale(1.03);
        border-color: var(--accent);
    }

    .dpp-pill-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        margin-top: 6px;
        width: 100%;
    }

    .dpp-pill {
        background: var(--accent);
        color: #fff;
        padding: 6px 10px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 13px;
        display: inline-block;
    }

    .dpp-tabs {
        display: flex;
        gap: 8px;
        margin-top: 12px;
        border-radius: 8px;
        overflow: hidden;
        background: #fbfdff;
        padding: 6px;
        border: 1px solid #edf2ff;
    }

    .dpp-tab {
        flex: 1;
        text-align: center;
        padding: 8px 10px;
        font-size: 14px;
        border-radius: 8px;
        cursor: pointer;
        color: #374151;
        background: transparent;
        border: none;
        white-space: normal;
        word-break: break-word;
    }

    .dpp-tab.active {
        background: linear-gradient(90deg, rgba(16,185,129,0.08), rgba(37,99,235,0.03));
        border: 1px solid rgba(16,185,129,0.12);
        color: #0f172a;
        font-weight: 600;
    }

    .dpp-tab-content {
        display: none;
        margin-top: 12px;
    }

    .dpp-tab-content.active {
        display: block;
    }

    .dpp-specs {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .dpp-spec-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        align-items: center;
    }

    .dpp-spec-label {
        font-weight: 600;
        color: #111827;
        font-size: 14px;
    }

    .dpp-spec-value {
        font-size: 14px;
        color: #374151;
    }

    .dpp-trace-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
        margin-top: 10px;
    }

    .dpp-trace-card {
        background: var(--card);
        border-radius: 10px;
        padding: 12px;
        border: 1px solid var(--soft-border);
        box-shadow: 0 4px 10px rgba(15,23,42,0.04);
        display: flex;
        flex-direction: column;
        gap: 8px;
        cursor: pointer;
    }

    .dpp-trace-card img {
        width: 100%;
        border-radius: 8px;
        max-height: 300px;
        object-fit: cover;
    }

    .dpp-impact-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 6px;
    }

    .dpp-impact-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-radius: 10px;
        background: var(--card);
        border: 1px solid var(--soft-border);
    }

    .dpp-impact-left {
        display: flex;
        gap: 12px;
        align-items: center;
    }

    .dpp-impact-blob {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: #f1f5f9;
    }

    .dpp-impact-title {
        font-weight: 600;
        font-size: 13px;
        color: #111827;
    }

    .dpp-impact-value {
        font-weight: 700;
        font-size: 14px;
        color: #111827;
    }

    .dpp-social {
        margin-top: 6px;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
    }

    .dpp-social .dpp-main {
        width: 100%;
        max-width: 420px;
        border-radius: 10px;
        object-fit: cover;
    }

    .dpp-social .dpp-thumbs {
        justify-content: center;
    }

    .dpp-instructions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 6px;
    }

    .dpp-instruction {
        padding: 12px;
        border-radius: 10px;
        background: var(--card);
        border: 1px solid var(--soft-border);
        display: flex;
        gap: 12px;
        align-items: flex-start;
    }

    .dpp-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
        border-top: 1px solid var(--soft-border);
        gap: 12px;
    }

    .dpp-footer img {
        width: 140px;
        max-width: 50%;
        height: auto;
        display: block;
        filter: invert(1);
    }

    @media (max-width: 880px) {
        .dpp-page {
            max-width: 560px;
        }
        .dpp-trace-grid {
            grid-template-columns: 1fr;
        }
        .dpp-header {
            padding: 10px;
            height: 72px;
        }
        .dpp-profile img {
            width: 48px;
            height: 48px;
        }
    }

    @media (max-width: 420px) {
        .dpp-container {
            padding: 12px;
        }
        .dpp-profile .dpp-title {
            font-size: 15px;
        }
        .dpp-main-image {
            max-width: 100%;
        }
        .dpp-thumbs img {
            width: 70px;
            height: 54px;
        }
    }
`;

// Chevron SVG Component
const ChevronIcon: React.FC<{ rotated?: boolean }> = ({ rotated }) => (
    <svg
        className={`dpp-chev ${rotated ? 'rotated' : ''}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
    >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
    </svg>
);

const DdpModal: React.FC<DdpCProps> = ({ user }) => {
    console.log("user in ddp is ", user);

    const [expandedSection, setExpandedSection] = useState<string>('details');
    const [expandedAccordion, setExpandedAccordion] = useState<number | null>(null);
    const [activeTab, setActiveTab] = useState<string>('description');
    const [mainImage, setMainImage] = useState(user?.productImages?.[0]?.url || '');
    const [mainImage2, setMainImage2] = useState<string>(user?.socialImpact?.[0]?.url || '');

    useEffect(() => {
        // Inject CSS styles
        const styleElement = document.createElement('style');
        styleElement.id = 'dpp-modal-styles';
        styleElement.textContent = cssStyles;

        // Only add if not already present
        if (!document.getElementById('dpp-modal-styles')) {
            document.head.appendChild(styleElement);
        }

        return () => {
            const existingStyle = document.getElementById('dpp-modal-styles');
            if (existingStyle) {
                document.head.removeChild(existingStyle);
            }
        };
    }, []);

    useEffect(() => {
        if (user?.productImages?.[0]?.url) {
            setMainImage(user.productImages[0].url);
        }
        if (user?.socialImpact?.[0]?.url) {
            setMainImage2(user.socialImpact[0].url);
        }
    }, [user]);

    const toggleSection = (section: string) => {
        const newSection = expandedSection === section ? '' : section;
        setExpandedSection(newSection);
        if (section === 'traceability' && newSection === 'traceability') {
            setExpandedAccordion(1);
        } else if (newSection === '') {
            setExpandedAccordion(null);
        }
    };

    const toggleAccordion = (id: number) => {
        setExpandedAccordion(expandedAccordion === id ? null : id);
    };

    const traceabilityData = user?.processes?.map((process: any, index: number) => ({
        id: index + 1,
        title: process.processName,
        country: process.country,
        processedBetween: process.facilityName,
        imageSrc: process.image,
        organization: process.facilityName,
        address: process.address,
        certifications: process.certifications,
    })) || [];

    const { currentUser, auth, isFacilityManager, isSupplyChainManager }: any = useAuth();

    const image = isSupplyChainManager
        ? auth?.data?.profileImage || ''
        : isFacilityManager
            ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
            : isSupplyChainManager
                ? currentUser?.franchiseKycDoc?.filter((x: any) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
                : currentUser?.kycDocument?.filter((x: any) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
                currentUser?.kycDocument?.filter((x: any) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl;

    return (
        <div className="dpp-container">
            <main className="dpp-page">
                <section className="dpp-card" aria-label="Product Card">
                    {/* Header */}
                    <header className="dpp-header" role="banner">
                        <div className="dpp-profile">
                            <img
                                src={image || toAbsoluteUrl('/dppImge.png')}
                                alt="Profile"
                                style={{
                                    width: '52px',
                                    height: '52px',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    borderRadius: '8px',
                                    border: '1px solid #e6e6e6'
                                }}
                            />
                            <div style={{ minWidth: 0, textAlign: 'center' }}>
                                <div className="dpp-title">Digital Product Passport</div>
                            </div>
                        </div>
                    </header>

                    {/* Content */}
                    <div className="dpp-content">
                        {/* Product Details Section */}
                        <article className="dpp-section">
                            <div className="dpp-head" onClick={() => toggleSection('details')}>
                                <div className="dpp-head-left">
                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                        <div className="dpp-head-title">Product Details</div>
                                    </div>
                                </div>
                                <ChevronIcon rotated={expandedSection === 'details'} />
                            </div>
                            <div className="dpp-head">
                                <div className="dpp-head-left">
                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                        <div className="dpp-head-sub">{user?.description || ''}</div>
                                    </div>
                                </div>
                            </div>

                            <div className={`dpp-body ${expandedSection !== 'details' ? 'hidden' : ''}`}>
                                <h2 className="dpp-head-title">{user?.productName || ''}</h2>

                                <div className="dpp-media">
                                    <img src={mainImage} alt="Main product" className="dpp-main-image" />

                                    <div className="dpp-thumbs">
                                        {(user?.productImages || []).map((img: any, idx: number) => (
                                            <img
                                                key={idx}
                                                src={img.url}
                                                alt={`thumb${idx + 1}`}
                                                data-image={img.url}
                                                onClick={() => setMainImage(img.url)}
                                            />
                                        ))}
                                    </div>

                                    <div className="dpp-pill-row">
                                        <span className="dpp-pill">Best Seller</span>
                                        <div style={{ fontSize: '13px', color: 'var(--muted)' }}>{user?.productName || ''}</div>
                                    </div>

                                    <div style={{ width: '100%' }}>
                                        {/* Tabs */}
                                        <div className="dpp-tabs" role="tablist" aria-label="Product tabs">
                                            <button
                                                className={`dpp-tab ${activeTab === 'description' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('description')}
                                                aria-selected={activeTab === 'description'}
                                            >
                                                Details
                                            </button>
                                            <button
                                                className={`dpp-tab ${activeTab === 'practical-info' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('practical-info')}
                                            >
                                                Features
                                            </button>
                                            <button
                                                className={`dpp-tab ${activeTab === 'our-mission' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('our-mission')}
                                            >
                                                Specs
                                            </button>
                                        </div>

                                        {/* Tab Contents */}
                                        <div className={`dpp-tab-content ${activeTab === 'description' ? 'active' : ''}`}>
                                            <p className="dpp-lead">{user?.aboutBrand || ''}</p>
                                        </div>

                                        <div className={`dpp-tab-content ${activeTab === 'practical-info' ? 'active' : ''}`}>
                                            <p className="dpp-lead">{user?.aboutItem || ''}</p>
                                        </div>

                                        <div className={`dpp-tab-content ${activeTab === 'our-mission' ? 'active' : ''}`}>
                                            <div className="dpp-specs">
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Material</div>
                                                    <div className="dpp-spec-value">{user?.categoryName || ''}</div>
                                                </div>
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Plastics</div>
                                                    <div className="dpp-spec-value">{user?.itemName || ''}</div>
                                                </div>
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Product</div>
                                                    <div className="dpp-spec-value">{user?.productName || ''}</div>
                                                </div>
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Dimension</div>
                                                    <div className="dpp-spec-value">{user?.dimension || ''}</div>
                                                </div>
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Weight</div>
                                                    <div className="dpp-spec-value">{user?.weight || ''}</div>
                                                </div>
                                                <div className="dpp-spec-row">
                                                    <div className="dpp-spec-label">Packaging</div>
                                                    <div className="dpp-spec-value">{user?.categoryName || ''}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>

                        {/* Manufacturing Section */}
                        <article className="dpp-section">
                            <div className="dpp-head" onClick={() => toggleSection('manufacturing')}>
                                <div className="dpp-head-left">
                                    <div>
                                        <div className="dpp-head-title">Manufacturing Information</div>
                                        <div className="dpp-head-sub">Batch & facility details</div>
                                    </div>
                                </div>
                                <ChevronIcon rotated={expandedSection === 'manufacturing'} />
                            </div>

                            <div className={`dpp-body ${expandedSection !== 'manufacturing' ? 'hidden' : ''}`}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px 6px' }}>
                                    <div className="dpp-spec-row">
                                        <div className="dpp-spec-label">Batch ID</div>
                                        <div className="dpp-spec-value">{user?.production?.productionId || ''}</div>
                                    </div>
                                    <div className="dpp-spec-row">
                                        <div className="dpp-spec-label">Batch Weight</div>
                                        <div className="dpp-spec-value">{user?.totalWeight || ''}</div>
                                    </div>
                                    <div className="dpp-spec-row">
                                        <div className="dpp-spec-label">Date of Production</div>
                                        <div className="dpp-spec-value">{user?.actualProcessDate || ''}</div>
                                    </div>
                                    <div className="dpp-spec-row">
                                        <div className="dpp-spec-label">Facility Name</div>
                                        <div className="dpp-spec-value">{user?.pickupPointName || ''}</div>
                                    </div>
                                    <div className="dpp-spec-row">
                                        <div className="dpp-spec-label">Address</div>
                                        <div className="dpp-spec-value">{user?.pickupPointAddress || ''}</div>
                                    </div>
                                </div>
                            </div>
                        </article>

                        {/* Traceability Section */}
                        <article className="dpp-section">
                            <div className="dpp-head" onClick={() => toggleSection('traceability')}>
                                <div className="dpp-head-left">
                                    <div>
                                        <div className="dpp-head-title">Material Traceability</div>
                                        <div className="dpp-head-sub">Where materials came from</div>
                                    </div>
                                </div>
                                <ChevronIcon rotated={expandedSection === 'traceability'} />
                            </div>

                            <div className={`dpp-body ${expandedSection !== 'traceability' ? 'hidden' : ''}`}>
                                <div className="dpp-trace-grid">
                                    {traceabilityData.map((item: any) => (
                                        <div
                                            key={item.id}
                                            className="dpp-trace-card"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ fontWeight: 700 }}>{item.title}</div>
                                                <ChevronIcon rotated={expandedAccordion === item.id} />
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--muted)', fontSize: '13px' }}>
                                                <div>Country</div>
                                                <div>{item.country}</div>
                                            </div>
                                            {expandedAccordion === item.id && (
                                                <>
                                                    <img src={item.imageSrc} alt="Recycling facility" />
                                                    <div style={{ fontWeight: 700 }}>Organization</div>
                                                    <div style={{ color: 'var(--muted)', fontSize: '13px' }}>
                                                        {item.organization} • {item.address}
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <div style={{ fontWeight: 700 }}>Certifications</div>
                                                        <div>{item.certifications}</div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </article>

                        {/* Impact Section */}
                        <article className="dpp-section">
                            <div className="dpp-head" onClick={() => toggleSection('impact')}>
                                <div className="dpp-head-left">
                                    <div>
                                        <div className="dpp-head-title">Impact</div>
                                        <div className="dpp-head-sub">Environmental and social impact</div>
                                    </div>
                                </div>
                                <ChevronIcon rotated={expandedSection === 'impact'} />
                            </div>

                            <div className={`dpp-body ${expandedSection !== 'impact' ? 'hidden' : ''}`}>
                                <div className="dpp-impact-list">
                                    <div className="dpp-impact-item">
                                        <div className="dpp-impact-left">
                                            <div className="dpp-impact-blob" style={{ background: '#dcfce7' }}>
                                                <img
                                                    src="https://inclusive.asmglobal.co.in/media/svg/dashboard/GHG_saving.png"
                                                    alt="GHG Savings"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                            <div>
                                                <div className="dpp-impact-title">GHG Savings (Kg)</div>
                                            </div>
                                        </div>
                                        <div className="dpp-impact-value">{user?.co2Savings || 0}</div>
                                    </div>

                                    <div className="dpp-impact-item">
                                        <div className="dpp-impact-left">
                                            <div className="dpp-impact-blob" style={{ background: '#dbeafe' }}>
                                                <img
                                                    src="https://inclusive.asmglobal.co.in/media/svg/dashboard/energy_saved.png"
                                                    alt="Energy Savings"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                            <div>
                                                <div className="dpp-impact-title">Energy Saved (Kwh)</div>
                                            </div>
                                        </div>
                                        <div className="dpp-impact-value">{user?.energySavings || 0}</div>
                                    </div>

                                    <div className="dpp-impact-item">
                                        <div className="dpp-impact-left">
                                            <div className="dpp-impact-blob" style={{ background: '#fee2e2' }}>
                                                <img
                                                    src="https://inclusive.asmglobal.co.in/media/svg/dashboard/waste_saved.png"
                                                    alt="Water Savings"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                            <div>
                                                <div className="dpp-impact-title">Water Saved (Liter)</div>
                                            </div>
                                        </div>
                                        <div className="dpp-impact-value">{user?.waterSavings || 0}</div>
                                    </div>

                                    <div className="dpp-impact-item">
                                        <div className="dpp-impact-left">
                                            <div className="dpp-impact-blob" style={{ background: '#fef3c7' }}>
                                                <img
                                                    src="https://inclusive.asmglobal.co.in/media/svg/dashboard/trees_saved.png"
                                                    alt="Tree Savings"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                            <div>
                                                <div className="dpp-impact-title">Trees Saved (No.)</div>
                                            </div>
                                        </div>
                                        <div className="dpp-impact-value">{user?.treeSavings || 0}</div>
                                    </div>
                                </div>

                                {/* Social Impact */}
                                <div className="dpp-social" style={{ width: '100%', marginTop: '10px' }}>
                                    <div style={{ fontWeight: 700 }}>Social Impact</div>
                                    <img src={mainImage2} alt="Main social" className="dpp-main" />
                                    <div className="dpp-thumbs">
                                        {(user?.socialImpact || []).map((img: any, idx: number) => (
                                            <img
                                                key={idx}
                                                src={img.url}
                                                alt={`sthumb${idx + 1}`}
                                                data-social-image={img.url}
                                                onClick={() => setMainImage2(img.url)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </article>

                        {/* End of Life Section */}
                        <article className="dpp-section">
                            <div className="dpp-head" onClick={() => toggleSection('end-of-life')}>
                                <div className="dpp-head-left">
                                    <div>
                                        <div className="dpp-head-title">End of Life</div>
                                        <div className="dpp-head-sub">Reuse • Repair • Recycle</div>
                                    </div>
                                </div>
                                <ChevronIcon rotated={expandedSection === 'end-of-life'} />
                            </div>

                            <div className={`dpp-body ${expandedSection !== 'end-of-life' ? 'hidden' : ''}`}>
                                <div className="dpp-instructions">
                                    {/* Reuse */}
                                    {user?.reuseInfo?.[0] && (
                                        <div className="dpp-instruction">
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 700 }}>Reuse Instructions</div>
                                                <div style={{ color: 'var(--muted)', fontSize: '13px', marginTop: '6px' }}>
                                                    {user.reuseInfo[0].text}
                                                </div>
                                                {user.reuseInfo[0].url && (
                                                    <a
                                                        href={user.reuseInfo[0].url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'inline-block',
                                                            marginTop: '8px',
                                                            marginBottom: '8px',
                                                            color: '#2563eb',
                                                            fontSize: '13px',
                                                            textDecoration: 'underline'
                                                        }}
                                                    >
                                                        {user.reuseInfo[0].url}
                                                    </a>
                                                )}
                                                {user.reuseInfo[0].image && (
                                                    <div className="dpp-media">
                                                        <img src={user.reuseInfo[0].image} alt="Reuse" className="dpp-main-image" />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Repair */}
                                    {user?.repairInfo?.[0] && (
                                        <div className="dpp-instruction">
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 700 }}>Repair Instructions</div>
                                                <div style={{ color: 'var(--muted)', fontSize: '13px', marginTop: '6px' }}>
                                                    {user.repairInfo[0].text}
                                                </div>
                                                {user.repairInfo[0].url && (
                                                    <a
                                                        href={user.repairInfo[0].url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'inline-block',
                                                            marginTop: '8px',
                                                            marginBottom: '8px',
                                                            color: '#2563eb',
                                                            fontSize: '13px',
                                                            textDecoration: 'underline'
                                                        }}
                                                    >
                                                        {user.repairInfo[0].url}
                                                    </a>
                                                )}
                                                {user.repairInfo[0].image && (
                                                    <div className="dpp-media">
                                                        <img src={user.repairInfo[0].image} alt="Repair" className="dpp-main-image" />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Recycle */}
                                    {user?.recycleInfo?.[0] && (
                                        <div className="dpp-instruction">
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 700 }}>Recycle Instructions</div>
                                                <div style={{ color: 'var(--muted)', fontSize: '13px', marginTop: '6px' }}>
                                                    {user.recycleInfo[0].text}
                                                </div>
                                                {user.recycleInfo[0].url && (
                                                    <a
                                                        href={user.recycleInfo[0].url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'inline-block',
                                                            marginTop: '8px',
                                                            marginBottom: '8px',
                                                            color: '#2563eb',
                                                            fontSize: '13px',
                                                            textDecoration: 'underline'
                                                        }}
                                                    >
                                                        {user.recycleInfo[0].url}
                                                    </a>
                                                )}
                                                {user.recycleInfo[0].image && (
                                                    <div className="dpp-media">
                                                        <img src={user.recycleInfo[0].image} alt="Recycle" className="dpp-main-image" />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </article>

                        {/* Footer */}
                        <footer className="dpp-footer">
                            <img
                                src="/media/logos/new_logo.png"
                                alt="Footer logo"
                            />
                        </footer>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default DdpModal;